import { Component, OnInit, Input, inject, DestroyRef, ChangeDetectionStrategy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { BaseComponent, ProductService, StorageService, UserService } from "@mypxplat/xplat/core";
import { Router, NavigationEnd } from "@angular/router";
import moment from "moment";
import { AppService, FirebaseService } from "@mypxplat/xplat/web/core";
import { LinkFenderAccountComponent, RegisterProductComponent, RegisterSuccessSplashComponent, StudiooneGracePeriodComponent } from "../modals";
import { TranslateService } from "@ngx-translate/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-s1-status-header",
  templateUrl: "s1-status-header.component.html",
  standalone: false,
})
export class S1StatusHeaderComponent extends BaseComponent implements OnInit {
  public randomBackgroundImage: string;
  private destroyRef = inject(DestroyRef);
  public shouldShowMemDayPromoBanner: boolean = false;
  public showStudioProDemoCta: boolean = new Date() >= new Date(this.env.studioProDemoLaunchDate);

  constructor(
    public storage: StorageService,
    public userService: UserService,
    public productService: ProductService,
    public appService: AppService,
    public router: Router,
    public fbService: FirebaseService,
    public translate: TranslateService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.randomBackgroundImage = this.picRandomBackgroundImage();

    // Subscribe to studioOneStatus changes
    this.productService.studioOneStatus$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((status) => {
      if (status?.status == "not_registered") {
        this.productService.studioOneStatus = {
          status: "register_product_cta",
          message: this.translate.instant("profile.register_product_message"),
        };
        this.productService.studioOneStatus$.next(this.productService.studioOneStatus);
      }

      if (status?.status) {
        const today = new Date();
        const may28th = new Date(2026, 4, 28);
        this.shouldShowMemDayPromoBanner = today < may28th && status?.status != "registered_perpetual" && status?.status != "registered_subscription";
      }
    });
  }

  registerProduct() {
    this.appService.closeModals();
    this.appService.showModal(RegisterProductComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
  }

  picRandomBackgroundImage() {
    const images = [
      "/assets/images/hero/fui-hero3.jpg",
      "/assets/images/hero/fui-hero4.jpg",
      "/assets/images/hero/fui-hero5.jpg",
      "/assets/images/hero/fui-hero6.jpg",
      // "/assets/images/hero/fui-hero8.jpg",
      "/assets/images/hero/fui-hero10.jpg",
      "/assets/images/hero/fui-hero11.jpg",
      "/assets/images/hero/fui-hero12.jpg",
      "/assets/images/hero/fui-hero13.jpg",
      "/assets/images/hero/fui-hero14.jpg",
    ];
    return images[Math.floor(Math.random() * images.length)];
  }

  linkFenderAccount() {
    this.appService.showModal(LinkFenderAccountComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
  }

  showFspRedeem() {
    const modalRef = this.appService.showModal(StudiooneGracePeriodComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
  }
}
